// extracted by mini-css-extract-plugin
export default {"editor":"MailEditor_editor__AUQl9","readOnly":"MailEditor_readOnly__FclaK","toolbar":"MailEditor_toolbar__FRkql"};